angular.module("avant.services")

.service "AvantErrorService", ->

  # ============================================
  # The PI filter list is maintained in 2
  # locations and both must be updated.
  # 1- Here in this file.
  # 2- config/filter_pi.yml
  # ============================================
  filters = [
    new RegExp('ssn', 'i'),
    new RegExp('password', 'i'),
    new RegExp('card_number', 'i'),
    new RegExp('security', 'i'),
    new RegExp('date_of_birth', 'i'),
    new RegExp('account_number', 'i'),
    new RegExp('credit_card', 'i'),
    new RegExp('routing', 'i'),
    new RegExp('login', 'i'),
    new RegExp('bank', 'i'),
    new RegExp('birthday', 'i')]


  # ============================================
  # filter_params(object)
  # ============================================
  filter_params = (obj) ->
    obj = angular.copy obj
    for own k,v of obj
      if typeof obj[k] == "object"
        obj[k] = filter_params obj[k]
      for filter_regex in filters
        if filter_regex.test k
          obj[k] = '[FILTERED]'
    obj

  # Our original service, honeybadger, has been removed because the company is
  # shifting away from it, and now using Sentry. This service has been left intact
  # for ease of integration with a new error reporting framework.

  # The remaining no-op methods below may be utilized in the future.
  svc =
    appendContext: (key, record) ->
    setContext: (context) ->
    clearContext: (context) ->
    notify: (error, context) ->
      window.Sentry?.captureException(error);

.factory "$exceptionHandler", ["AvantErrorService", "$log", "$window", (AvantErrorService, $log, $window) ->
  (exception, cause) ->
    $log.error exception

    # Don't report local (saved page) errors
    if $window.location.protocol isnt 'file:'
      AvantErrorService.notify exception
]
